import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/components/404.vue';
import CreateAccount from '@/components/CreateAccount.vue';
import Contact from '@/components/Contact.vue';
import ChooseForm from '@/components/ChooseForm.vue';
import Stage2 from '@/components/Stage2.vue';
import Stage3 from '@/components/Stage3.vue';
import Stage4 from '@/components/Stage4.vue';
import Stage5 from '@/components/Stage5.vue';
import Information from '@/components/stage3/Information.vue';
import Address from '@/components/stage3/Address.vue';
import ManagedLLC from '@/components/stage3/ManagedLLC.vue';
import ManagedCCorp from '@/components/stage3/ManagedCCorp.vue';
import ManagedSCorp from '@/components/stage3/ManagedSCorp.vue';
import ManagedNonProfit from '@/components/stage3/ManagedNonProfit.vue';
import Agent from '@/components/stage4/Agent.vue';
import EIN from '@/components/stage4/EIN.vue';
import OpAgree from '@/components/stage4/OpAgree.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/choose',
    },
    {
      path: '/:route/contact',
      component: Contact,
    },
    {
      path: '/create-account',
      name: 'create-account',
      component: CreateAccount,
    },
    {
      path: '/choose',
      component: ChooseForm,
    },
    {
      path: '/stage2',
      component: Stage2,
    },
    {
      path: '/stage3',
      component: Stage3,
      children: [
        {
          path: 'info',
          component: Information,
        },
        {
          path: 'address',
          component: Address,
        },
        {
          path: 'managedllc',
          component: ManagedLLC,
        },
        {
          path: 'managedccorp',
          component: ManagedCCorp,
        },
        {
          path: 'managedscorp',
          component: ManagedSCorp,
        },
        {
          path: 'managednonprofit',
          component: ManagedNonProfit,
        },
      ],
    },
    {
      path: '/stage4',
      component: Stage4,
      children: [
        {
          path: 'agent',
          component: Agent,
        },
        {
          path: 'ein',
          component: EIN,
        },
        {
          path: 'opagree',
          component: OpAgree,
        },
      ],
    },
    {
      path: '/stage5',
      component: Stage5,
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
});
